import React from 'react';
import IntlMessages from '../../../../../../../util/IntlMessages';
import DirectionIcon from './DirectionIcon';
import styles from '../../Synonyms.module.scss';

export const TypeExplanation = () => (
  <aside className={styles.explanation}>
    <h3 className={styles.explanationTitle}>
      <IntlMessages id="search.synonyms.types.title" />
    </h3>
    <div className={styles.explanationGrid}>
      <div className={`${styles.explanationItem} ${styles.explanationBidirectional}`.trim()}>
        <span className={styles.explanationIcon} aria-hidden="true">
          <DirectionIcon variant="exchange" />
        </span>
        <p>
          <strong>
            <IntlMessages id="search.synonyms.bidirectional.label" />
          </strong>
          <span>
            <IntlMessages id="search.synonyms.bidirectional.description" />
          </span>
        </p>
      </div>
      <div className={`${styles.explanationItem} ${styles.explanationUnidirectional}`.trim()}>
        <span className={styles.explanationIcon} aria-hidden="true">
          <DirectionIcon variant="forward" />
        </span>
        <p>
          <strong>
            <IntlMessages id="search.synonyms.unidirectional.label" />
          </strong>
          <span>
            <IntlMessages id="search.synonyms.unidirectional.description" />
          </span>
        </p>
      </div>
    </div>
  </aside>
);
